/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";
import SoundManager from "../../SoundManager";

export class Grass extends PIXI.Container {
  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y


    // const grass = new CustomAnimatedSprite(0,0, resources, R.spines.grass)

    // grass.playAnimation(R.spines.grass.animations.animation, true)
    // this.addChild(grass)
  }

}



// WEBPACK FOOTER //
// ./src/game/characters/level2/Grass.js